import { Order } from "@today/api/taker"

export function formatInvoiceNumber(unformatted?: string): string {
  const formatted = unformatted?.match(/.{4}/g)?.join("-") ?? ""
  return formatted.length === 14 ? formatted : unformatted ?? ""
}

// EM123456789KR -> EM-123456789-KR
export function formatEmsInvoiceNumber(unformatted?: string) {
  if (!unformatted) return unformatted ?? ""
  return unformatted?.replace(/^([A-Z]{2})(\d{9})([A-Z]{2})$/, "$1-$2-$3")
}

export function detectInvoiceFormat(
  unformatted?: string,
  forwardingName?: string
) {
  if (!unformatted) {
    return ""
  }

  if (forwardingName === "EMS" && unformatted?.length === 13) {
    return formatEmsInvoiceNumber(unformatted)
  }

  const formattedInvoiceNumber = formatInvoiceNumber(unformatted)

  // forwardingInfo.name이 존재하면서 12자리 숫자가 아닌경우 예약 송장번호임.
  if (forwardingName && !/^\d{12}$/.test(unformatted)) {
    return `(예약 송장번호) ${formattedInvoiceNumber}`
  }

  return formattedInvoiceNumber
}

export type DetectInvoiceFormatAtPartnerOrder = Pick<
  Order,
  "invoiceNumber" | "forwardingInfo"
>

/**
 * 파트너 앱에서 주문의 송장번호를 표기한다.
 *
 * 위탁 송장번호가 발급돼 있으면 그 번호를, 아직 없으면 자체 송장번호를 쓴다.
 * "(예약 송장번호)" 표기는 자체 송장번호를 쓰는 경우에만 붙는다.
 */
export function detectInvoiceFormatAtPartner(
  order: DetectInvoiceFormatAtPartnerOrder
): string {
  const { invoiceNumber, deliveryOrganizationName } = order.forwardingInfo ?? {}
  if (invoiceNumber) {
    // detectInvoiceFormat 은 배송사명이 있으면 "(예약 송장번호)" 접두를 붙인다. 위탁 번호가
    // 있다는 것은 발급이 끝났다는 뜻이므로, 그 함수를 쓰지 않고 하이픈만 넣는다.
    return deliveryOrganizationName === "EMS"
      ? formatEmsInvoiceNumber(invoiceNumber)
      : formatInvoiceNumber(invoiceNumber)
  }
  return detectInvoiceFormat(order.invoiceNumber, deliveryOrganizationName)
}
